<template>
  <div class="row no-gutters unidata-editor-correlator">
    <el-select v-model="currentUnidataEditor" placeholder="Select" class="col-6 pr-3">
      <el-option
        v-for="(item, index) in unidataDropdownCalculated"
        :key="item.id"
        v-tooltip="uniToolTipTranslation(item.label, 'en-US')"
        :label="uniTranslation(item.label)"
        :value="index"
      ></el-option>
    </el-select>
    <div v-if="unidataDropdown.length > 0" :class="cssClass">
      <UnidataEditor
        v-for="d in unidataDropdown"
        v-show="d.visible"
        :key="d.id"
        :ref="d.id"
        class="pl-2"
        :parent-path="parentPath"
        :name="d.name"
        :unidata-editor-columns="'col-8'"
      ></UnidataEditor>
    </div>
  </div>
</template>

<script>
import jsonHelper from "../../shared/jsonHelper";
import { mapGetters } from "vuex";
import conversionService from "../../services/backend/conversionService";
import { Select, Option } from "element-ui";
import UnidataEditor from "./UnidataEditor.vue";
export default {
  components: {
    "el-option": Option,
    "el-select": Select,
    UnidataEditor
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    group: {
      type: String,
      required: true
    },
    cssClass: {
      type: String,
      default: "col-6"
    },
    selectedOptionIndex: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      unidataDropdownCalculated: [],
      currentUnidataEditor: 0,
      unidataEditors: [],
      unsubscribes: [],
      unidataDropdown: []
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects"]),
    order() {
      if (this.unidataDropdownCalculated.length === 0) return 9999;
      return this.unidataDropdownCalculated[this.currentUnidataEditor].order;
    }
  },
  watch: {
    currentUnidataEditor: function(newval /*, oldval*/) {
      if (newval != undefined) {
        this.updateUnidataEditorsVisibility(newval);
      }

      var that = this;
      if (newval != undefined) {
        /*this.unidataEditors(newval).isOptionSelected = true;
          this.unidataEditors(oldval).isOptionSelected = false;*/
        //QUI LOGICA DI SWITCH INPUT OUTPUT TRA 'OLD' E 'NEW' VAL
        that.$emit("update:selectedOptionIndex", newval);
        this.$emit("changedcombo", that.unidataDropdown[newval].name);
      }
    }
  },
  destroyed: function() {
    this.unsubscribes.forEach(function(u) {
      u();
    });
  },
  mounted: function() {
    var that = this;
    var datas = jsonHelper.getProperty(this.projects, this.parentPath);
    for (var d in datas) {
      if (datas[d]) {
        if (
          datas[d].group != undefined &&
          datas[d].group !== null &&
          datas[d].group === this.group
        ) {
          this.unidataDropdown.push({
            id: this.group + "_" + (parseInt(this.unidataDropdown.length) + 1),
            label: datas[d].label,
            name: "." + d,
            dato: datas[d],
            visible: false,
            order: datas[d].order,
            group: this.group,
            path: this.parentPath + "." + d
          });
        }
      }
    }

    // console.log(this.unidataDropdown);
    that.$nextTick(function() {
      that.unidataDropdown.forEach(function(el /*, index*/) {
        //=====================================
        //MARCO DC 19/11/2021
        /*
          Ho commentato il codice
          l'ho spostato nello subscribe dello store
          così i valori vengono aggiornati al cambio del refrigerante
          e non al cambio del valore => infatti se si cambiava il fluido
          senza toccare il valore, non veniva aggiornato niente
          adesso si
        */
        /*that.unsubscribes.push(
          that.$store.subscribe(function(mutation /*, state ) {
            let path = el.path + ".input.refValue.value";
            // let unidataIndex = index;
            if (mutation.type === "changeProjectProperty") {
              if (mutation.payload.path.startsWith(path)) {
                that.correlationFunction(el, path);
              }
            }
          })
        );*/

        //=====================================
        if (el.dato.behavior.isVisible) {
          that.unidataDropdownCalculated.push(el);
        }
      });

      that.unidataDropdownCalculated = that.unidataDropdownCalculated.sort(function(a, b) {
        return a.order <= b.order ? -1 : 1;
      });

      if (that.unidataDropdownCalculated.length > 0)
        that.unidataDropdownCalculated[0].visible = true;

      // console.log(that.unidataDropdownCalculated, that.unidataEditors);
      // that.updateUnidataEditorsVisibility(that.currentUnidataEditor);
    });

    this.$store.subscribe(function(mutation) {
      if (mutation.type === "changeProjectProperty") {
        if (mutation.payload.path.includes(".fluid.hasGlide")) {
          that.updateCorrelationValue();
        }
      }
    });
  },
  methods: {
    updateUnidataEditorsVisibility: function(index) {
      this.unidataDropdownCalculated.forEach(function(k) {
        k.visible = false;
      });
      this.unidataDropdownCalculated[index].visible = true;
    },

    correlationFunction(el, path) {
      var that = this;
      var prjName = path.substring(0, path.indexOf("."));

      var unidatoCorrelation = {
        changedPath: path,
        correlationList: [],
        group: el.group,
        project: that.projects[prjName]
      };

      that.unidataDropdown.forEach(function(el /*, index*/) {
        unidatoCorrelation.correlationList.push({
          path: el.path,
          unidato: jsonHelper.getProperty(that.projects, el.path)
        });
      });
      conversionService.convertCorrelatedUnidata(unidatoCorrelation).then(function(data) {
        data.forEach(function(el /*, index*/) {
          that.$store.dispatch("updateUnidato", {
            path: el.path,
            unidato: el.unidato
          });
        });
        that.$store.dispatch("refreshAll");
      });
    },

    getRefValue(defvalue, defum) {
      var x = {};
      x.value = defvalue;
      x.um = defum;

      var that = this;
      this.unidataDropdown.forEach(el => {
        if (el.visible) {
          var path = el.path + ".input.refValue";
          x = jsonHelper.getProperty(that.projects, path);
        }
      });

      return x;
    },

    setRefValue(newValue, rifUm) {
      var that = this;
      this.unidataDropdown.forEach(el => {
        if (el.visible) {
          that.$refs[el.id][0].setValue(newValue, rifUm);
        }
      });
    },

    updateCorrelationValue() {
      var that = this;
      this.unidataDropdown.forEach(el => {
        if (el.visible) {
          let path = el.path + ".input.refValue.value";
          that.correlationFunction(el, path);
        }
      });
    }
  }
};
</script>

<style lang="scss">
.unidata-editor-correlator > .el-select > .el-input {
  margin: 0 0 0px 0px !important;
  //padding: 10px 0;
}
.unidata-editor-correlator .el-select .el-input .el-input__inner {
  height: 30px !important;
}
</style>
